import { Component, OnInit } from '@angular/core';
import { ExampleNg6LibService } from './example-ng6-lib.service';

@Component({
  selector: 'enl-example-ng6-lib',
  template: `
    <button (click)="test()">test</button>
  `,
  styles: []
})
export class ExampleNg6LibComponent implements OnInit {

  constructor(private exampleNg6LibService: ExampleNg6LibService) { }

  ngOnInit() {

  }
  
  test() {
    this.exampleNg6LibService.test();
  }

}
